import { render, staticRenderFns } from "./allRouteList.vue?vue&type=template&id=5a58a605&scoped=true&lang=pug&"
import script from "./allRouteList.vue?vue&type=script&lang=js&"
export * from "./allRouteList.vue?vue&type=script&lang=js&"
import style0 from "./allRouteList.vue?vue&type=style&index=0&id=5a58a605&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a58a605",
  null
  
)

export default component.exports